<template>

  <div>

    <div v-for="group in grouped" :key="group.documentcategory">

      <div class="toggles" data-style="default">

        <div class="toggle extra-color-1">

          <h3><a href="#" class="uppercase"><i class="icon-plus-sign"></i>{{ group.description }}</a></h3>

          <div style="padding:16px 0">

            <div v-for="doc in group.items" :key="doc.documentid">
              <a class="flex items-center px-6 py-4 text-grey-darkest hover:text-poly-red hover:bg-grey-lightest" :href="doc.url" target="_blank">
                <div class="flex-auto pr-2" style="border-right:1px solid #eee;">{{ doc.documentname }}</div>
                <div class="text-sm uppercase pl-2">{{ doc.filetype }}</div>
              </a>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

export default {

  name: 'SupportAccordion',

  props: {

    docs: { type: Array }

  },

  computed: {

    grouped() {

      let grouped = {};
      let documentcategory = 0;
      let documentid = 0;

      this.docs.forEach(doc => {

        documentcategory = doc.documentcategory || '';
        documentid       = doc.documentid       || 0;

        grouped[documentcategory] = grouped[documentcategory] || {};
        grouped[documentcategory]['category'] = doc.documentcategory;
        grouped[documentcategory]['description'] = doc.documentcategory_description;

        grouped[documentcategory]['items'] = grouped[documentcategory]['items'] || {};
        grouped[documentcategory]['items'][documentid] = grouped[documentcategory]['items'][documentid] || {};
        grouped[documentcategory]['items'][documentid]['documentid'] = documentid;
        grouped[documentcategory]['items'][documentid]['documentname'] = doc.documentname;
        grouped[documentcategory]['items'][documentid]['url'] = doc.url;
        grouped[documentcategory]['items'][documentid]['filetype'] = doc.filetype;

      });

      return grouped;
    }

  }

}
</script>
